import React, { Component } from 'react';
import { bool, instanceOf, func, oneOfType } from 'prop-types';
import { Route } from 'react-router-dom';
import RulesInfo from '../RulesInfo';
import Stepper from '../../features/Stepper';
import Navbar from '../../features/Navbar';
import Menu from '../../features/Menu';
import { Button } from '../Buttons';

import {
  Container,
  Content,
  DarkOverlay,
  Wrapper,
  InactivatedBox,
} from './styles';

DefaultLayout.propTypes = {
  component: oneOfType([instanceOf(Component), func]),
  isStartPage: bool.isRequired,
  toggleMenu: func.isRequired,
  menuOpen: bool.isRequired,
  render: func,
  isInactivated: bool.isRequired,
  inactivatedBy: func,
  canBeActivated: func,
  reactivateApplication: func,
  makeSpaceForNotificationBar: bool.isRequired,
  toggleStatusBar: func.isRequired,
  statusBarOpen: bool.isRequired,
};

DefaultLayout.defaultProps = {
  component: null,
  render: null,
  inactivatedBy: null,
  canBeActivated: null,
  reactivateApplication: null,
};

function DefaultLayout({
  component: RouteComponent,
  menuOpen,
  isStartPage,
  toggleMenu,
  isInactivated,
  inactivatedBy,
  canBeActivated,
  reactivateApplication,
  makeSpaceForNotificationBar,
  toggleStatusBar,
  statusBarOpen,
  ...rest
}) {
  return (
    <Route
      {...rest}
      render={matchProps => (
        <React.Fragment>
          {isInactivated && (
            <DarkOverlay
              inactivatedView
              makeSpaceForNotificationBar={makeSpaceForNotificationBar}>
              <InactivatedBox>
                <h4>Denna Bytesansökan har avbrutits</h4>
                <p>Avbruten av {inactivatedBy()}</p>
                {canBeActivated() && (
                  <Button big primary onClick={reactivateApplication}>
                    Återaktivera
                  </Button>
                )}
              </InactivatedBox>
            </DarkOverlay>
          )}
          <Navbar
            isStartPage={isStartPage}
            menuOpen={menuOpen}
            toggleMenu={toggleMenu}
            toggleStatusBar={toggleStatusBar}
            statusBarOpen={statusBarOpen}
          />
          <Wrapper makeSpaceForNotificationBar={makeSpaceForNotificationBar}>
            {!isStartPage && (
              <Stepper
                makeSpaceForNotificationBar={makeSpaceForNotificationBar}
                statusBarOpen={statusBarOpen}
              />
            )}
            <Content>
              {!isStartPage && (
                <Container>
                  <Menu open={menuOpen} toggleMenu={toggleMenu} />
                </Container>
              )}
              {menuOpen && <DarkOverlay onClick={toggleMenu} />}
              <Container mainView>
                <RulesInfo />
                <RouteComponent {...matchProps} />
              </Container>
            </Content>
          </Wrapper>
        </React.Fragment>
      )}
    />
  );
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/components/DefaultLayout/DefaultLayout.js